import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { 
  GetSalesImportQueryResponse, 
  GetSalesImportsQueryResponse, 
  CreateSalesImportCommand, 
  UpdateSalesImportCommand 
} from '../interfaces/interfaces';

@Injectable({
  providedIn: 'root'
})
export class SalesImportService {
  private baseUrl: string;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.apiSite.endsWith('/') 
      ? environment.apiSite.slice(0, -1) 
      : environment.apiSite;
  }

  // Get a single sales import by ID
  getSalesImport(params: { id: number }): Observable<GetSalesImportQueryResponse> {
    return this.http.get<GetSalesImportQueryResponse>(`${this.baseUrl}/api/SalesImport/${params.id}`);
  }

  // Get all sales imports
  getAllSalesImports(): Observable<GetSalesImportsQueryResponse> {
    return this.http.get<GetSalesImportsQueryResponse>(`${this.baseUrl}/api/SalesImport`);
  }

  // Create a new sales import
  createSalesImport(command: CreateSalesImportCommand): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/SalesImport`, command);
  }

  // Update an existing sales import
  updateSalesImport(command: UpdateSalesImportCommand): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/api/SalesImport`, command);
  }
}
